import React from 'react';
import * as Types from './types';

import LiveHelpIcon from '@material-ui/icons/LiveHelp';
import ChatIcon from '@material-ui/icons/Chat';
import ExternalLinkNavItem from './ExternalLinkNavItem';

const supportLinks = [
  {
    header: { title: 'Help Articles' },
    link: 'https://help.justsift.com',
    Icon: LiveHelpIcon,
  },
  {
    header: { title: 'Chat' },
    link: 'mailto:support@justsift.com',
    Icon: ChatIcon,
    id: 'intercom-chat',
  },
] as Types.ExternalLinkNavItem[];

function SupportLinks() {
  return (
    <>
      {supportLinks.map((item, i) => {
        return <ExternalLinkNavItem item={item} key={`support-link-${i}`} />;
      })}
    </>
  );
}

export default SupportLinks;
